module.exports = __webpack_public_path__ + "static/media/1POLICY21.9e25aca6.jpg";